export const USER_STATUS_LABELS = {
  active: 'Active',
  inactive: 'Inactive',
};

export const USER_STATUS_FILTER_OPTIONS = [
  { value: '', label: 'All statuses' },
  { value: 'true', label: USER_STATUS_LABELS.active },
  { value: 'false', label: USER_STATUS_LABELS.inactive },
];

export const USER_STATUS_MESSAGES = {
  deactivateSuccess: 'User deactivated successfully.',
  activateSuccess: 'User activated successfully.',
  deactivateFailed: 'Failed to deactivate user. Please try again.',
  activateFailed: 'Failed to activate user. Please try again.',
  cannotDeactivateSelf: 'You cannot deactivate your own account.',
  deactivateTitle: 'Deactivate user?',
  activateTitle: 'Activate user?',
  deactivateBody:
    'will lose access immediately and will not be able to sign in until reactivated.',
  activateBody: 'will regain access and be able to sign in again.',
};
